module.exports = __webpack_public_path__ + "static/sfprd-logo-big-5c38833743685457ff680b9433f9fc2b.png";